import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Form,
  Button,
  Image,
  Card,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { Dropdown, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import Footer from "../Footer/Footer";
import { useProjectName } from "../../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CircularProgress } from "@mui/material";
import Cookies from 'js-cookie';
import { Country } from "country-state-city";
import validateEmail from "../../../utils/validateEmail";
import validatePhoneNumber from "../../../utils/validatePhoneNumber";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const SignUp = () => {
  let navigate = useNavigate();
  const projectName = useProjectName();
  const { t, i18n } = useTranslation();
  const [loadingFull, setLoadingFull] = useState(false);
  const [logo, setLogo] = useState("");

  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdownLang = () => setDropdownVisible(!isDropdownVisible);
  const closeDropdownLang = () => setDropdownVisible(false);

  const changeLanguage = (lng) => {
        localStorage.setItem("i18nextLng",lng)
        Cookies.set("language", lng, { expires: 30 });
    i18n.changeLanguage(lng);
    closeDropdownLang();
  };

  const countries = Country?.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
  }));
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileCode: "+00",
    mobile: "",
    email: "",
    password: "",
    emailOTP: "",
    mobileOTP: "",
    confirmPassword: "",
    country:""
  });
  const [autoDetected, setAutoDetected] = useState("");

  useEffect(() => {
    axios.get("https://ipapi.co/json/")
      .then((res) => {
        const userCountryCode = res.data.country_code;
        setAutoDetected(userCountryCode);
        setFormData((prev) => ({ ...prev, country: userCountryCode }));
      })
      .catch((err) => console.error("Geo error:", err));
  }, [setFormData]);

  const [tc, setTc] = useState(false);
  const handlePhoneChange = (value) => {
    setFormData((prevState) => ({
      ...prevState,
      mobile: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: val,
    }));

    if (name === "password") {
      const isValid = validatePassword(val);
      if (!isValid) {
        setPasswordError(
          "At least 8 characters with upper/lowercase, number, and special character."
        );
      } else {
        setPasswordError("");
      }
    }
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    return regex.test(password);
  };

  const [passwordError, setPasswordError] = useState("");
  const [categorypost, setCategorypost] = useState("individual");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "firstName",
      "lastName",
      // "mobileCode",
      // "mobile",
      "email",
      "password",
      "confirmPassword",
      "country"
      // "type",
    ];
    for (const field of requiredFields) {
      if (!formData[field]) {
        toast.error(`${field} is required.`);
        return;
      }
    }
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    if (!validatePassword(formData.password)) {
      setPasswordError(
        "At least 8 characters with upper/lowercase, number, and special character."
      );
      return;
    }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/user/register`,
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          mobileCode: formData.mobileCode,
          mobile: formData.mobile,
          email: formData.email,
          password: formData.password,
          clientUseFor: categorypost,
          country: formData.country,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Registered Successfully", response.data);
      toast.success(response.data.message);
      navigate("/auth/sign-in");
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while signing up.");
      }

      console.log("Error in Sign up", error);
    } finally {
      setLoadingFull(false);
    }
  };
  const [generate, setGenerate] = useState(true);
  const [verify, setVerify] = useState(false);
  const [generateMobile, setGenerateMobile] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);
  const [register, setRegister] = useState(false);

  // Generate OTP
  const handleGenerateOTP = async (e) => {
    e.preventDefault();
    if (!formData.firstName) {
      toast.error("Please enter first name");
      return;
    }
    if (!formData.lastName) {
      toast.error("Please enter last name");
      return;
    }
    if (!formData.email) {
      toast.error("Please enter Email");
      return;
    }
          setLoadingFull(true);

         if (!(await validateEmail(formData.email))) {
        toast.error("Invalid Email");
            setLoadingFull(false)
        return;
      }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/generateOTP`,
        {
          mobile: formData.mobile,
          email: formData.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("OTP Send Successfully", response.data);
      toast.success(response.data.message);
      setGenerate(false);
      setVerify(true);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while generating OTP.");
      }

      console.log("Error in Generating OTP", error);
    } finally {
      setLoadingFull(false);
    }
  };

  // Verify OTP
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (!formData.emailOTP) {
      toast.error("Please Enter OTP");
      return;
    }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/verifyOTP`,
        {
          email: formData.email,
          emailOTP: formData.emailOTP,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("OTP Verified Successfully", response.data);
      toast.success(response.data.message);
      setVerify(false);
      setGenerateMobile(true);
      // setRegister(true);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while verifying OTP.");
      }

      console.log("Error in verifying OTP", error);
    } finally {
      setLoadingFull(false);
    }
  };
  const handleGenerateOTPMobile = async (e) => {
    e.preventDefault();
    if (!formData.mobile) {
      toast.error("Please Enter Mobile Number");
      return;
    }
        setLoadingFull(true)
    
      if (!(await validatePhoneNumber(formData.mobile))) {
        toast.error("Invalid phone number.");
            setLoadingFull(false)
        return;
      }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/mobile-generateOTP`,
        {
          mobile: formData.mobile,
          verificationFor: "sign-up",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("OTP Send Successfully", response.data);
      toast.success(response.data.message);
      setGenerateMobile(false);
      setVerifyMobile(true);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while generating OTP.");
      }

      console.log("Error in Generating OTP", error);
    } finally {
      setLoadingFull(false);
    }
  };

  // Verify OTP
  const handleVerifyOTPMobile = async (e) => {
    e.preventDefault();
    if (!formData.mobileOTP) {
      toast.error("Please Enter OTP");
      return;
    }
    try {
      setLoadingFull(true);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/auth/mobile-verifyOTP`,
        {
          mobile: formData.mobile,
          mobileOTP: formData.mobileOTP,
          verificationFor: "sign-up",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("OTP Verified Successfully", response.data);
      toast.success(response.data.message);
      setVerifyMobile(false);
      setRegister(true);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while verifying OTP.");
      }

      console.log("Error in verifying OTP", error);
    } finally {
      setLoadingFull(false);
    }
  };
  const [popupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };
  const closePopup = () => {
    setPopupOpen(false);
  };

  const handleLogo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/footer?status=true`
      );
      const logoLink = response?.data?.data?.enableMaintenanceMode?.logoLink;
      setLogo(logoLink || "");
    } catch (error) {
      console.log("Error fetching logo", error);
    }
  };
  useEffect(() => {
    handleLogo();
  }, []);
  const [finalNumberShow, setFinalNumberShow] = useState(true);
  const directPassword = () => {
    setVerifyMobile(false);
    setRegister(true);
    setGenerateMobile(false);
    setFinalNumberShow(false);
    setFormData({
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      mobileCode: "+00",
      mobile: "",
      email: formData?.email,
      password: "",
      confirmPassword: "",
      country:formData?.country
    });
  };
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      {loadingFull && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      <section className="sign-in-page" style={{ height: "100vh" }}>
        <Modal
          size="md"
          className="fade custom-modal"
          id="qr-modal"
          onHide={closePopup}
          show={popupOpen}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Terms and Conditions</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center custom-modal-body">
            <div>
              <h3>Terms and Conditions</h3>
              <p>
                Welcome to our application. These terms and conditions outline
                the rules and regulations for the use of our services.
              </p>
              <p>
                By accessing this application, we assume you accept these terms
                and conditions in full. Do not continue to use our application
                if you do not accept all of the terms and conditions stated on
                this page.
              </p>

              <h4>License</h4>
              <p>
                Unless otherwise stated, we and/or our licensors own the
                intellectual property rights for all material on the
                application. All intellectual property rights are reserved. You
                may view and/or print pages from the application for your own
                personal use subject to restrictions set in these terms and
                conditions.
              </p>

              <h4>User Comments</h4>
              <p>
                This Agreement shall begin on the date hereof. Certain parts of
                this application offer the opportunity for users to post and
                exchange opinions, information, material, and data ('Comments')
                in areas of the application. We do not screen, edit, publish, or
                review Comments prior to their appearance on the application and
                Comments do not reflect the views or opinions of us, our agents,
                or affiliates. Comments reflect the view and opinion of the
                person who posts such view or opinion. To the extent permitted
                by applicable laws, we shall not be responsible or liable for
                the Comments or for any loss cost, liability, damages, or
                expenses caused and or suffered as a result of any use of and/or
                posting of and/or appearance of the Comments on this
                application.
              </p>

              <h4>iFrames</h4>
              <p>
                Without prior approval and express written permission, you may
                not create frames around our web pages or use other techniques
                that alter in any way the visual presentation or appearance of
                our application.
              </p>

              <h4>Content Liability</h4>
              <p>
                We shall have no responsibility or liability for any content
                appearing on your application. You agree to indemnify and defend
                us against all claims arising out of or based upon your
                application.
              </p>

              <h4>Reservation of Rights</h4>
              <p>
                We reserve the right at any time and in its sole discretion to
                request that you remove all links or any particular link to our
                application. You agree to immediately remove all links to our
                application upon such request.
              </p>

              <h4>Removal of Links from our Application</h4>
              <p>
                If you find any link on our application or any linked website
                objectionable for any reason, you may contact us about this. We
                will consider requests to remove links but will have no
                obligation to do so or to respond directly to you.
              </p>

              <h4>Disclaimer</h4>
              <p>
                To the maximum extent permitted by applicable law, we exclude
                all representations, warranties, and conditions relating to our
                application and the use of this application. Nothing in this
                disclaimer will:
              </p>
            </div>
          </Modal.Body>
        </Modal>
        <Container
          className="p-0"
          style={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {logo && (
            <div
              style={{
                fontSize: "30px",
                letterSpacing: "4px",
                color: "white",
                fontWeight: "600",
                textTransform: "uppercase",
              }}
              className={window.innerWidth <= 768 ? "mobile-margin-top" : ""}
            >
              {/* {projectName}  */}
              <img src={logo} alt="logo" style={{ width: "120px" }} />
            </div>
          )}

          <Row
            className="no-gutters"
            style={{
              borderRadius: "10px",
              overflow: "auto",
              justifyContent: "center",
              display: "flex",
              margin: "20px",
            }}
          >
            {/* For register */}

            <Col
              md="12"
              className="bg-white pt-2  pb-2"
              style={{ height: "auto", overflowY: "hidden", width: "400px" }}
            >
              <div className="sign-in-from" style={{ paddingInline: "20px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className="mb-0">{t("sign_up_heading")}</h3>
                  <div style={{display:"flex"}}>
                  <select
  id="country"
  name="country"
  value={formData.country}
  onChange={handleChange}
  style={{
    margin: "10px",
    padding: "5px",
    width: "140px",
    border:"none",
    borderbottom:"1px solid black"
  }}
  required
>
  <option value="">Select a country</option>
  {countries?.map((country, index) => (
    <option key={index} value={country.value}>
      {country.label}
    </option>
  ))}
</select>
                  <Dropdown
                    // as="li"
                    className="nav-item"
                    style={{ alignContent: "center" }}
                    show={isDropdownVisible}
                  >
                    <Dropdown.Toggle
                      href="#"
                      as="div"
                      onClick={toggleDropdownLang}
                      className="d-flex align-items-center text-primary position-relative"
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className="material-symbols-outlined text-primary"
                        title="Language"
                        style={{ fontSize: "24px", lineHeight: "1" }}
                      >
                        language
                      </i>
                      <span className="mobile-text d-none ms-3">Language</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="sub-drop">
                      <Card className="shadow-none mb-3 m-0" style={{ maxHeight: "40vh" }}>
                        <Card.Header className="d-flex justify-content-between bg-primary">
                          <div className="header-title bg-primary">
                            <h5 className="mb-0 text-white">Language</h5>
                          </div>
                          <div
                            className="text-white d-flex align-items-center justify-content-center"
                            style={{ width: "40px", height: "40px" }}
                            onClick={closeDropdownLang}
                          >
                            <span className="material-symbols-outlined">
                              close
                            </span>
                          </div>
                        </Card.Header>

                        <Card.Body
                          className="p-5 mb-3 "
                          style={{ maxHeight: "40vh", overflowY: "auto" }}
                        >
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("en")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">English</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("fr")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Français</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("de")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Deutsch</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("it")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Italiano</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("pt")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Português</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("ar")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">العربية</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("tr")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Türkçe</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("ru")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Русский</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("hi")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">हिन्दी</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("ja")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">日本語</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("ko")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">한국어</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("nl")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Nederlands</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("el")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Ελληνικά</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("th")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">ไทย</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("vi")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Tiếng Việt</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("uk")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Українська</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("ro")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Română</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("armenian")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Հայերեն</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("chinese")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">中文</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("mandarin")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">普通话</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("urdu")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">اردو</h6>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            className="iq-sub-card"
                            onClick={() => changeLanguage("es")}
                          >
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-0 ">Español</h6>
                              </div>
                            </div>
                          </Link>
                        </Card.Body>
                      </Card>
                    </Dropdown.Menu>
                  </Dropdown>
                  </div>
                </div>
                {/* <p>Enter your email address and password to access admin panel.</p> */}
                <Form className="mt-2" onSubmit={(e) => handleSubmit(e)}>
                  <Form.Group className="form-group">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        gap: "5px",
                      }}
                    >
                      <Form.Label
                        className="mb-0 flex"
                        style={{ width: "50%" }}
                      >
                        {t("first_name_label")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Label className="mb-0 flex">
                        {t("last_name_label")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        gap: "5px",
                      }}
                    >
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="mb-0 flex"
                        id="firstName"
                        placeholder={t("first_name_label")}
                        required
                      />
                      <Form.Control
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="mb-0 flex"
                        id="lastName"
                        placeholder={t("last_name_label")}
                        required
                      />
                    </div>
                  </Form.Group>
                  {generate && (
                    <Form.Group className="form-group">
                      <Form.Label>
                        {t("email_label")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="mb-0"
                        id="email"
                        placeholder={t("email_placeholder")}
                        required
                      />
                      {/* {formData.email && (
                                                <button type="button" className="btn btn-link rounded-pill float-end" onClick={handleGenerateOTP}>Send OTP</button>
                                          )}         */}
                    </Form.Group>
                  )}
                  {verify && (
                    <>
                      <Form.Group className="form-group">
                        <Form.Label>{t("email_label")} </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          className="mb-0"
                          id="email"
                          placeholder={t("email_placeholder")}
                          disabled
                        />
                        <div style={{display:"flex"}}>
                          <button
    type="button"
    className="btn btn-link p-0"
          style={{ whiteSpace: "nowrap", marginLeft: "auto" }}
    onClick={handleGenerateOTP}
  >
    Resend OTP
  </button>
  </div>
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>{t("otp_label")}<span style={{ color: "red" }}>*</span></Form.Label>
                        <Form.Control
                          type="number"
                          name="emailOTP"
                          value={formData.emailOTP}
                          onChange={handleChange}
                          className="mb-0"
                          id="emailOTP"
                          placeholder={t("otp_placeholder")}
                          required
                        />
                        {/* <button type="button" class="btn btn-link rounded-pill float-end" onClick={handleVerifyOTP}>Verify OTP</button> */}
                      </Form.Group>
                    </>
                  )}

                  {generateMobile && (
                    <Form.Group className="form-group">
                      <Form.Label>
                        {t("phone_label")}
                      </Form.Label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "5px",
                        }}
                      >
                        <PhoneInput
                          country={(formData?.country || "us").toLowerCase()}
                          value={formData.mobile}
                          onChange={handlePhoneChange}
                          style={{ height: "35px !important" }}
                          inputStyle={{
                            width: "100%",
                            height: "35px !important",
                          }}
                          containerStyle={{
                            marginBottom: "10px",
                            height: "35px",
                          }}
                          placeholder="Enter your phone number"
                          required
                        />
                      </div>
                    </Form.Group>
                  )}
                  {verifyMobile && (
                    <>
                      <Form.Group className="form-group">
                        <Form.Label>{t("phone_label")}</Form.Label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            gap: "5px",
                          }}
                        >
                          <PhoneInput
                          country={(formData?.country || "us").toLowerCase()}
                          value={formData.mobile}
                            onChange={handlePhoneChange}
                            style={{ height: "35px !important" }}
                            inputStyle={{
                              width: "100%",
                              height: "35px !important",
                            }}
                            containerStyle={{
                              marginBottom: "10px",
                              height: "35px",
                            }}
                            placeholder="Enter your phone number"
                            disabled
                          />
                        </div>
                                            <div style={{display:"flex"}}>
                          <button
    type="button"
    className="btn btn-link p-0"
          style={{ whiteSpace: "nowrap", marginLeft: "auto" }}
    onClick={handleGenerateOTPMobile}
  >
    Resend OTP
  </button>
  </div>
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>{t("otp_label")}<span style={{ color: "red" }}>*</span></Form.Label>
                        <Form.Control
                          type="number"
                          name="mobileOTP"
                          value={formData.mobileOTP}
                          onChange={handleChange}
                          className="mb-0"
                          id="mobileOTP"
                          placeholder={t("otp_placeholder")}
                          required
                        />
                        {/* <button type="button" class="btn btn-link rounded-pill float-end" onClick={handleVerifyOTP}>Verify OTP</button> */}
                      </Form.Group>
                    </>
                  )}
                  {register && (
                    <div>
                      <Form.Group className="form-group">
                        <Form.Label>{t("email_label")}</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          className="mb-0"
                          id="email"
                          placeholder={t("email_placeholder")}
                          disabled
                        />
                        <button
                          type="button"
                          class="btn btn-link rounded-pill float-end text-green"
                        >
                          {t("verified_status_text")}
                        </button>
                      </Form.Group>
                      {finalNumberShow && (
                        <Form.Group className="form-group">
                          <Form.Label>{t("phone_label")}</Form.Label>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              gap: "5px",
                            }}
                          >
                            <PhoneInput
                          country={(formData?.country || "us").toLowerCase()}
                          value={formData.mobile}
                              onChange={handlePhoneChange}
                              style={{ height: "35px !important" }}
                              inputStyle={{
                                width: "100%",
                                height: "35px !important",
                              }}
                              containerStyle={{
                                marginBottom: "10px",
                                height: "35px",
                              }}
                              placeholder="Enter your phone number"
                              disabled
                            />
                          </div>
                          <button
                            type="button"
                            class="btn btn-link rounded-pill float-end text-green"
                          >
                            {t("verified_status_text")}
                          </button>
                        </Form.Group>
                      )}
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("type")} <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <div
                          className="mb-0"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Check
                            type="radio"
                            name="category"
                            value="individual"
                            label={t("category_individual_label")}
                            checked={categorypost === "individual"}
                            onChange={handleCategoryChange}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginRight: "20px",
                            }}
                            required
                          />
                          <Form.Check
                            type="radio"
                            name="category"
                            value="business"
                            label={t("category_business_label")}
                            checked={categorypost === "business"}
                            onChange={handleCategoryChange}
                            style={{ display: "flex", alignItems: "center" }}
                            required
                          />
                        </div>
                      </Form.Group>

                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("password_label")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="mb-0"
                          id="password"
                          placeholder={t("password_label")}
                          required
                        />
                        {passwordError && (
                          <div className="text-danger">{passwordError}</div>
                        )}
                      </Form.Group>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("confirm_password_label")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          className="mb-0"
                          id="confirmPassword"
                          placeholder={t("confirm_password_label")}
                          required
                        />
                      </Form.Group>
                    </div>
                  )}
                  <div className="d-inline-block w-100">
                    {/* <Form.Check className="d-inline-block mt-1 pt-1">
                      <Form.Check.Input
                        type="checkbox"
                        name="agreeToTerms"
                        checked={tc}
                        onChange={(e) => setTc(e.target.value)}
                        className="me-1"
                        id="agreeToTerms"
                        required
                      />
                      <Form.Check.Label>
                        {t('agree_terms_text')}{" "}
                        <Link onClick={openPopup}>{t('terms_link')}</Link>
                      </Form.Check.Label>
                    </Form.Check> */}
                    {generate && (
                      <Button
                        className="btn-primary float-end"
                        onClick={handleGenerateOTP}
                      >
                        {t("send_otp_button")}
                      </Button>
                    )}

                    {verify && (
                      <Button
                        className="btn-primary float-end"
                        onClick={handleVerifyOTP}
                      >
                        {t("verify_otp_button")}
                      </Button>
                    )}
                    {generateMobile && (
                      <div>
                        <Button
                          className="btn-primary float-end mx-2"
                          onClick={directPassword}
                        >
                          Proceed without Phone number
                        </Button>
                        <Button
                          className="btn-primary float-end"
                          onClick={handleGenerateOTPMobile}
                        >
                          {t("send_otp_button")}
                        </Button>
                      </div>
                    )}

                    {verifyMobile && (
                      <Button
                        className="btn-primary float-end"
                        onClick={handleVerifyOTPMobile}
                      >
                        {t("verify_otp_button")}
                      </Button>
                    )}
                    {register && (
                      <>
                        <Form.Check className="d-inline-block mt-1 pt-1">
                          <Form.Check.Input
                            type="checkbox"
                            name="agreeToTerms"
                            checked={tc}
                            onClick={(e) => setTc(!tc)}
                            className="me-1"
                            id="agreeToTerms"
                            required
                          />
                          <Form.Check.Label>
                            {t("agree_terms_text")}{" "}
                            <Link onClick={openPopup}>{t("terms_link")}</Link>
                          </Form.Check.Label>
                        </Form.Check>
                        <Button type="submit" disabled={!tc}className="btn-primary float-end">
                          {t("sign_up_heading")}
                        </Button>
                      </>
                    )}
                  </div>
                  <div className="sign-info">
                    <span className="dark-color d-inline-block line-height-1">
                      {t("already_have_account")}{" "}
                      <Link to="/auth/sign-in">{t("log_in_link")}</Link>
                    </span>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default SignUp;
